import React from "react";
import { Row, Col, Divider } from "antd";
import { useWindowsSize } from "../../libs";
import { Link } from "react-router-dom";
import ErrorPage from "../Notification/Error";

function RegisterPage({ props }) {
  const {
    data,
    view,
    isError,
    loading,
    onView,
    onChange,
    onSubmit,
    isTab,
    onTab,
  } = props;
  const size = useWindowsSize();
  let width = size.width;

  // overflow-scroll overflow-x-hidden register-scroll

  return (
    <div className="w-full overflow-hidden">
      <Row>
        <Col lg={16} md={16} sm={24} xs={24}>
          <div
            className={
              width > 1366
                ? "login p-5 md:pt-10 md:px-14 lg:pt-4 lg:px-10 xl:pt-12 xl:px-24"
                : "login p-5 md:pt-10 md:px-14 lg:pt-4 lg:px-10 xl:pt-6 xl:px-24"
            }
          >
            <div
              name="icon-header"
              className={
                width > 1366 ? "flex mb-6 lg:mb-8" : "flex mb-6 lg:mb-6"
              }
            >
              <Link to="/">
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "/assets/logo/logo_kemenkes.svg"
                  }
                  alt="kemenkes-logo"
                  className="h-10 w-auto mr-10 lg:h-10 xl:h-12"
                />
              </Link>
              <Link to="/">
                <img
                  src={
                    process.env.REACT_APP_BASE_URL + "/assets/logo/logo_blk.svg"
                  }
                  alt="blk-logo"
                  className="h-10 w-auto lg:h-10 xl:h-12 "
                />
              </Link>
            </div>
            <div
              name="title"
              className={`mb-2 ${width > 1366 ? "lg:mb-8" : "lg:mb-4"}`}
            >
              <p className="header-title login-p text-2xl md:text-4xl lg:text-3xl xl:text-5xl xl:mb-5">
                Ayo,{" "}
                <b className="header-title-bold font-extrabold">
                  Segera Mendaftar
                </b>
              </p>
              {size.width <= 640 && (
                <p className="header-title login-p-two font-semibold text-xs md:text-sm lg:text-lg xl:text-xl">
                  Isi form dibawah ini untuk melanjutkan
                </p>
              )}
            </div>

            {/* Tab Section */}
            <div className="-mb-3 flex items-center">
              <div className="flex items-center ">
                <div
                  className={`${
                    isTab === 1 ? "bg-blue" : "bg-grey"
                  } w-8 h-8 rounded-full  flex items-center justify-center`}
                >
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "/assets/icon/ic_data_diri.svg"
                    }
                    className="w-5 h-5"
                    alt="ic-datadiri"
                  />
                </div>
                <p
                  className={`font-bold ${
                    isTab === 1 ? "header-title-bold" : "header-title"
                  } text-base ml-2`}
                >
                  Data diri
                </p>
              </div>
              <div className="flex items-center  ml-10">
                <div
                  className={`${
                    isTab === 2 ? "bg-blue" : "bg-grey"
                  } w-8 h-8 rounded-full  flex items-center justify-center`}
                >
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "/assets/icon/ic_keamanan.svg"
                    }
                    className="w-5 h-5"
                    alt="ic-datadiri"
                  />
                </div>
                <p
                  className={`font-bold ${
                    isTab === 2 ? "header-title-bold" : "header-title"
                  } text-base ml-2`}
                >
                  Kemanan akun
                </p>
              </div>
            </div>
            <Divider />

            <div
              name="container-form"
              className={`w-full mt-3 lg:w-8/12 xl:w-9/12 ${
                width > 640 && "pr-5 -mt-3"
              }`}
              style={width > 640 ? { height: "62vh" } : {}}
            >
              {width <= 640 && (
                <div className="flex justify-end">
                  <img
                    className="h-auto w-10/12"
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "/assets/element_login_right.svg"
                    }
                    alt="ic_graphic"
                  />
                </div>
              )}
              {isTab === 1 && (
                <>
                  <Row>
                    <Col span={12}>
                      <div name="first-name-form" className="mb-6 mr-1">
                        <p className="login-title-form mb-3 text-xl lg:text-2xl">
                          Nama Depan
                        </p>
                        <input
                          onChange={onChange}
                          disabled={loading}
                          name="first_name"
                          className={`${
                            loading ? "input-disabled" : "form-input"
                          } outline-none w-full p-3`}
                          placeholder="John"
                          value={data.first_name}
                        />
                        {isError
                          ? isError.length > 0
                            ? isError
                                .filter((it) => it.type === "first_name")
                                .map((its, idx) => (
                                  <ErrorPage
                                    key={idx}
                                    props={{ idx, message: its.message }}
                                  />
                                ))
                            : null
                          : null}
                      </div>
                    </Col>
                    <Col span={12}>
                      <div name="last-name-form" className="mb-6 ml-1">
                        <p className="login-title-form mb-3 text-xl lg:text-2xl">
                          Nama Belakang
                        </p>
                        <input
                          onChange={onChange}
                          disabled={loading}
                          name="last_name"
                          className={`${
                            loading ? "input-disabled" : "form-input"
                          } outline-none w-full p-3`}
                          placeholder="Doe"
                          value={data.last_name}
                        />

                        {isError
                          ? isError.length > 0
                            ? isError
                                .filter((it) => it.type === "last_name")
                                .map((its, idx) => (
                                  <ErrorPage
                                    key={idx}
                                    props={{ idx, message: its.message }}
                                  />
                                ))
                            : null
                          : null}
                      </div>
                    </Col>
                  </Row>
                  <div name="ktp-form" className="mb-6">
                    <p className="login-title-form mb-3 text-xl lg:text-2xl">
                      No. KTP
                    </p>
                    <input
                      value={data.no_ktp === 0 ? undefined : data.no_ktp}
                      onChange={onChange}
                      disabled={loading}
                      name="no_ktp"
                      pattern="[0-9]*"
                      maxLength={16}
                      type="text"
                      className={`${
                        loading ? "input-disabled" : "form-input"
                      } outline-none w-full p-3`}
                      placeholder="Masukkan No. KTP anda"
                    />

                    {isError
                      ? isError.length > 0
                        ? isError
                            .filter((it) => it.type === "no_ktp")
                            .map((its, idx) => (
                              <ErrorPage
                                key={idx}
                                props={{ idx, message: its.message }}
                              />
                            ))
                        : null
                      : null}
                  </div>
                  <Row>
                    <Col span={12}>
                      <div name="email-form" className="mb-6  mr-1">
                        <p className="login-title-form mb-3 text-xl lg:text-2xl">
                          Email
                        </p>
                        <input
                          onChange={onChange}
                          disabled={loading}
                          name="email"
                          type="email"
                          className={`${
                            loading ? "input-disabled" : "form-input"
                          } outline-none w-full p-3`}
                          placeholder="Masukkan email anda"
                          value={data.email}
                        />

                        {isError
                          ? isError.length > 0
                            ? isError
                                .filter((it) => it.type === "email")
                                .map((its, idx) => (
                                  <ErrorPage
                                    key={idx}
                                    props={{ idx, message: its.message }}
                                  />
                                ))
                            : null
                          : null}
                      </div>
                    </Col>
                    <Col span={12}>
                      <div name="phone-form" className="mb-6 ml-1">
                        <p className="login-title-form mb-3 text-xl lg:text-2xl">
                          No. Telepon
                        </p>
                        <input
                          value={data.no_hp === 0 ? undefined : data.no_hp}
                          onChange={onChange}
                          disabled={loading}
                          name="no_hp"
                          maxLength={13}
                          pattern="[0-9]*"
                          type="tel"
                          className={`${
                            loading ? "input-disabled" : "form-input"
                          } outline-none w-full p-3`}
                          placeholder="Masukkan No. Telepon anda"
                        />

                        {isError
                          ? isError.length > 0
                            ? isError
                                .filter((it) => it.type === "no_hp")
                                .map((its, idx) => (
                                  <ErrorPage
                                    key={idx}
                                    props={{ idx, message: its.message }}
                                  />
                                ))
                            : null
                          : null}
                      </div>
                    </Col>
                  </Row>
                </>
              )}
              {isTab === 2 && (
                <>
                  <div name="password-form" className="mb-8 lg:mb-6">
                    <div className=" mb-3 flex justify-between items-center">
                      <p className="m-0 login-title-form text-xl lg:text-2xl">
                        Password
                      </p>
                    </div>
                    <div className="login-input-wrapper">
                      <input
                        onChange={onChange}
                        disabled={loading}
                        name="password"
                        type={view ? "text" : "password"}
                        className={`${
                          loading ? "input-disabled" : "form-input-icon"
                        } outline-none w-full p-3`}
                        placeholder="Masukkan password anda"
                        value={data.password}
                      />
                      <img
                        className="cursor-pointer w-5"
                        onClick={onView}
                        src={
                          process.env.REACT_APP_BASE_URL +
                          `/assets/icon/${
                            view ? "ic_forgot.svg" : "ic_hide.svg"
                          }`
                        }
                        alt="icon-forgot"
                      />
                    </div>

                    {isError
                      ? isError.length > 0
                        ? isError
                            .filter((it) => it.type === "password")
                            .map((its, idx) => (
                              <ErrorPage
                                key={idx}
                                props={{ idx, message: its.message }}
                              />
                            ))
                        : null
                      : null}
                  </div>
                  <div name="repassword-form" className="mb-8 lg:mb-6">
                    <div className=" mb-3 flex justify-between items-center">
                      <p className="m-0 login-title-form text-xl lg:text-2xl">
                        Konfirmasi Password
                      </p>
                    </div>
                    <div className="login-input-wrapper">
                      <input
                        onChange={onChange}
                        disabled={loading}
                        name="c_password"
                        type={view ? "text" : "password"}
                        className={`${
                          loading ? "input-disabled" : "form-input-icon"
                        } outline-none w-full p-3`}
                        placeholder="Konfirmasi password anda"
                        value={data.c_password}
                      />
                      <img
                        className="cursor-pointer w-5"
                        onClick={onView}
                        src={
                          process.env.REACT_APP_BASE_URL +
                          `/assets/icon/${
                            view ? "ic_forgot.svg" : "ic_hide.svg"
                          }`
                        }
                        alt="icon-forgot"
                      />
                    </div>

                    {isError
                      ? isError.length > 0
                        ? isError
                            .filter((it) => it.type === "c_password")
                            .map((its, idx) => (
                              <ErrorPage
                                key={idx}
                                props={{ idx, message: its.message }}
                              />
                            ))
                        : null
                      : null}
                  </div>
                </>
              )}
              <div name="button-save" className="mb-4">
                {/* <Link to="/account/verification"> */}
                <button
                  onClick={isTab === 1 ? () => onTab(2) : onSubmit}
                  className={`${
                    loading ? "btn-loading" : "btn-blue"
                  } w-full p-3 focus:outline-none`}
                >
                  <div className="flex justify-between items-center">
                    <div></div>
                    <p className="text-white font-semibold lg:text-lg flex items-center">
                      {loading
                        ? "Loading"
                        : isTab === 1
                        ? "Selanjutnya"
                        : "Register"}
                    </p>
                    {!loading ? (
                      <div>
                        <img
                          src={
                            process.env.REACT_APP_BASE_URL +
                            "/assets/icon/ic_arrow_right.svg"
                          }
                          alt="icon-arrow"
                        />
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </button>
                {/* </Link> */}
              </div>

              {isTab === 2 && (
                <p
                  onClick={isTab === 2 ? () => onTab(1) : null}
                  className="header-content font-bold text-blue-900 text-center mb-10 mt-3 cursor-pointer"
                >
                  Kembali ke Sebelumnya
                </p>
              )}
              <div className="flex items-center justify-between">
                <div name="info-section" className="">
                  <div
                    className={
                      width > 640
                        ? "flex items-center"
                        : "flex items-center justify-center"
                    }
                  >
                    <p className="header-content mr-3">Sudah punya akun ?</p>
                    <Link to="/account/login">
                      <p className="header-content font-semibold text-blue-900">
                        Login sekarang
                      </p>
                    </Link>
                  </div>
                </div>
                <div name="copy-section">
                  <div
                    className={
                      width > 640
                        ? "flex items-center"
                        : "flex items-center justify-center"
                    }
                  >
                    <img
                      src={
                        process.env.REACT_APP_BASE_URL +
                        "/assets/icon/ic_copyright.svg"
                      }
                      alt="icon-copyright"
                      className="mr-2 m-0"
                    />
                    <p className="header-content text-md text-gray-400">
                      SILK. all right reserved
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col lg={8} md={8} sm={0} xs={0}>
          <div name="content-right" className="login-right ">
            <div className="login-bg-right"></div>
          </div>
        </Col>
      </Row>
      {width > 640 && (
        <div
          style={{ width: width > 1366 ? "620px" : "550px", height: "auto" }}
          className="absolute top-16 right-0 flex-col float-right"
        >
          <img
            src={
              process.env.REACT_APP_BASE_URL + "/assets/element_login_right.svg"
            }
            className="float-right"
            alt="ic_graphic"
          />
          <div className=" flex justify-center ml-10 float-right">
            <div className=" w-2/4">
              <p className="header-title font-semibold text-white text-2xl">
                Pemeriksaan Aktual
              </p>
              <p className="header-content text-white">
                Menjadi laboratorium kesehatan nasional yang berkualitas,
                unggul, berbudaya dan berteknologi tinggi tahun 2024.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default RegisterPage;
